import {parseMessage} from 'lib/stringHelper';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';
import {CommonButtonLabel} from '../../../constants/dataEnum';
import {hideModal, showModal} from '../../actions/modalStateAction';
import {resolveIntl} from '../commonBusiness';
import {showFormattedModal, showModalSimplified} from '../commonModalBusiness';

const intl = resolveIntl();

export const showRemoveStuckTipAndReturnA1Position = (callback) => (dispatch) => {
  dispatch(
    showFormattedModal('setupWizard.step.a1OffsetCalibration.substep2.modal.removeStuckTip', [
      {
        label: CommonButtonLabel.GOT_IT,
        onClick: callback,
      },
    ]),
  );
};

export const showReplaceCaddyModal = (callback) => (dispatch) => {
  const idText = 'modal.setupWizard.checkTipPickup';

  dispatch(
    showModal(
      intl.formatMessage({id: `${idText}.title`}),
      <div className="modal-setup-wizard__replace-caddy">
        <FormattedHTMLMessage id={`${idText}.text`} />
        <img
          alt="./images/preparation-wizard/caddy-corner-removed-in-tray-confirmation.png"
          src="./images/preparation-wizard/caddy-corner-removed-in-tray-confirmation.png"
        />
      </div>,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
    ),
  );
};

export const showLowVolumeTraySetupRequired = () => (dispatch) => {
  const title = parseMessage('modal.setupWizard.lowVolumeTrayRequired.title');
  const text = parseMessage('modal.setupWizard.lowVolumeTrayRequired.text');

  const button = [{label: parseMessage(CommonButtonLabel.GOT_IT)}];

  dispatch(showModalSimplified(title, text, button));
};
